import { useTranslation } from "react-i18next";
import { Form } from "semantic-ui-react";

import { useSelectedDealer } from "components";
import { createFormHelper } from "lib/Form";
import { ASTERISK_PLACEHOLDER } from "modules/DealerOverviewDashboard/components";
import "modules/DealerOverviewDashboard/components/Service/components/OneI/OneI.scss";

import type { DealerOverviewFormPayload } from "modules/DealerOverviewDashboard/hooks";

const FormHelper = createFormHelper<DealerOverviewFormPayload>();

export const OneI = () => {
  const { t } = useTranslation();
  const { watch, setValue } = FormHelper.useFormContext();

  const { selectedDealer } = useSelectedDealer();
  const isOneiEnabled = watch("onei_planning_enabled");

  const clearOneiFields = (checked: boolean) => {
    if (checked) return;
    setValue("onei_planning_environment_guid", "");
    setValue("onei_planning_api_key", "");
  };

  return (
    <Form.Field width={8} className="OneI">
      <div className="dealer-overview-subheading">{t("v8_onei_planning_settings", "1i Planning Settings")}</div>
      <FormHelper.Field.Checkbox name="onei_planning_enabled" label={t("v8_onei_planning_enabled", "1i Planning enabled")} onChange={clearOneiFields} />
      {isOneiEnabled && (
        <>
          <Form.Field className="onei-field">
            <label>{t("v8_environment_guid", "Environment GUID")}</label>
            <FormHelper.Field.Input name="onei_planning_environment_guid" preventAutofill />
          </Form.Field>
          <Form.Field className="onei-field">
            <label>{t("v8_api_key", "API Key")}</label>
            <FormHelper.Field.Input
              name="onei_planning_api_key"
              preventAutofill
              inputProps={{ type: "password", placeholder: selectedDealer?.has_onei_planning_api_key ? ASTERISK_PLACEHOLDER : "" }}
            />
          </Form.Field>
        </>
      )}
    </Form.Field>
  );
};
